import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
//import apiService from '../services/apiservices'
//import { storesTableReady} from '../redux/kitchens'


import {addEditStoreKitchenDataForAction,addEditStoreIdForAction} from '../../Stores/redux/stores'

//import * as Constants from '../../../common/constants'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/kitchenTable.css'

import * as Helpers from '../../../common/helpers'


import {storesIdForAction} from '../../Stores/redux/stores'

class CollapsibleStoreRow extends Component {
    constructor() {
        super()
        this.state = {
        }
        this.dialog = null
    }

    componentWillMount() {
       
    }



     renderBuisnessStatus = (cell, row, enumObject, rowIndex) => {
        //debugger;
        

        let business_status=""


         business_status = <p>{row.business_status}<br/>[ {row.business_remarks} ]</p>


        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{business_status} </div>
        </div>)


         }


    addBtnCreator = (cell, row, enumObject, rowIndex) => {
        //debugger;
        

        let addBtn=""
        let editBtn=""

if(Helpers.checkPrivileges("/dashboard/stores/addEditTiming",this.props.user)){


        addBtn =<button
            className="action-button"
            style={{marginBottom: "1px" }}
            onClick={(e) => {
                e.preventDefault()
                this.addTimingFn(row)
            }}>
            <i className="fa fa-clock-o" aria-hidden="true"></i> Add Timing
        </button>
    }

    if(Helpers.checkPrivileges("/dashboard/stores/addEdit",this.props.user)){


        editBtn =<button
            className="action-button"
            style={{marginBottom: "1px",background: "#f0b209" }}
            onClick={(e) => {
                e.preventDefault()
                this.ediStoreFn(row)
            }}>
            <i className="fa fa-pencil-square" aria-hidden="true"></i> Edit Store
        </button>

    }
         
        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{addBtn} {editBtn}</div>
        </div>)
    }

    addTimingFn= (row) =>{

        if (row && row.id) {
                this.props.dispatch(storesIdForAction(row.id))
                this.props.history.push("/dashboard/stores/addEditTiming")
            } else {
                this.dialog.show({
                    title: "Store Identification number not found",
                    body: 'Store id is not available, So not able edit store',
                    actions: [
                        Dialog.OKAction(() => {
                        })
                    ],
                })
            }
        
    }

    ediStoreFn= (row) =>{

        if (row && row.id) {
                
            this.props.dispatch(addEditStoreIdForAction(row.id))
            this.props.dispatch(addEditStoreKitchenDataForAction())
                this.props.history.push("/dashboard/stores/addEdit")
            } else {
                this.dialog.show({
                    title: "Store Identification number not found",
                    body: 'Store id is not available, So not able edit store',
                    actions: [
                        Dialog.OKAction(() => {
                        })
                    ],
                })
            }
        
    }





      getStoreTimings = (cell, row) => {
       
        let storeTiming=[];
        if(row.store_timings.length>0){
            for (var i = 0; i < row.store_timings.length; i++) {
                storeTiming[i]=<p>{row.store_timings[i].time}</p>
            }
       }
        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{storeTiming}</div>
        </div>)
    }

     getStorePlatforms = (cell, row) => {
       
        let storePlatforms=[];
        if(row.store_platforms.length>0){
            for (var i = 0; i < row.store_platforms.length; i++) {
                storePlatforms[i]=<p>{row.store_platforms[i].platform}</p>
            }
       }
        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{storePlatforms}</div>
        </div>)
    }







    

    

    render() {
        const options = {
            page: 1,  // which page you want to show as default
            sizePerPage: 10,  // which size per page you want to locate as default
        }
        return (
            <div style={{ backgroundColor: "#e1e5ed",margin: "0% 4%" }}>
                <Dialog ref={el => this.dialog = el} />
                <BootstrapTable
                    className="table-border"
                    options={options}
                    data={this.props.row.stores}
                    hover={false}
                    headerStyle={{ border: '0px', color: '#000' }}
                    tableStyle={{ border: '0px' }}
                    bodyStyle={{ border: '0px', overflow: "auto" }}>

                    <TableHeaderColumn
                        dataField="id"
                        isKey={true}
                        hidden={true}
                        expandable={false}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal'}}>
                        Id
                    </TableHeaderColumn>
                   

                    <TableHeaderColumn
                        dataField="name"
                         dataSort={true}                        
                        className="table-header"
                        columnClassName="table-body"
                        dataAlign='left'
                        tdStyle={{background:"white"}}
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                        Store Name
                    </TableHeaderColumn> 

                    <TableHeaderColumn
                        dataField="brand_name"
                         dataSort={true}
                        className="table-header"
                        columnClassName="table-body"
                        dataAlign='left'
                        tdStyle={{background:"white"}}
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                        Brand
                    </TableHeaderColumn> 



                    <TableHeaderColumn
                        dataField="urbanpiper_id"
                        className="table-header"
                        columnClassName="table-body"
                        dataAlign='left'
                        tdStyle={{background:"white"}}
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                        UP Id
                    </TableHeaderColumn> 

                    <TableHeaderColumn
                        dataFormat={this.getStorePlatforms}
                        filterFormatted={true}
                        dataAlign='left'
                        tdStyle={{background:"white"}}
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                        Platforms
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        width="200"
                        dataFormat={this.getStoreTimings}
                        filterFormatted={true}
                        dataAlign='left'
                        tdStyle={{background:"white"}}
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                        Store Timings
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="status"
                        className="table-header"
                        columnClassName="table-body"
                        dataAlign='left'
                        tdStyle={{background:"white"}}
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                        Status
                    </TableHeaderColumn>  



                    <TableHeaderColumn
                        dataFormat={this.renderBuisnessStatus}
                        className="table-header"
                        columnClassName="table-body"
                        dataAlign='left'
                        tdStyle={{background:"white"}}
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                       Business Status
                    </TableHeaderColumn>   

                     <TableHeaderColumn
                        width="200"
                        expandable={false}
                        dataFormat={this.addBtnCreator}
                        dataAlign='left'
                        tdStyle={{background:"white"}}
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                        Actions
                    </TableHeaderColumn>              
                
                </BootstrapTable>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        stores: state.stores,
        user: state.user
    }
}

export default connect(mapStateToProps)(withRouter(CollapsibleStoreRow))


// WEBPACK FOOTER //
// ./src/modules/Kitchens/Components/CollapsibleStoreRow.js